import { getWeatherDescription, getWeatherIcon, getAQIDescription, getAQIColor } from '../../domain/utils/Weather/fetchWeather.js';

const WeatherCard = ({ weather }) => {
    if (!weather) return null;

    return (
        <div className="bg-gradient-to-br from-white/10 to-white/5 rounded-2xl shadow-2xl p-4 sm:p-6 backdrop-blur-xl border border-white/20 hover:border-green-400/50 transition-all duration-500 group">
            <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-white to-green-200 bg-clip-text text-transparent mb-4">Weather</h2>
            
            <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10 hover:border-green-400/50 transition-all">
                    <span className="text-gray-300 text-sm">Condition</span>
                    <div className="flex items-center gap-2">
                        <span className="text-xl">{getWeatherIcon(weather.weather_code)}</span>
                        <span className="text-white font-semibold text-sm">{getWeatherDescription(weather.weather_code)}</span>
                    </div>
                </div>

                <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10 hover:border-green-400/50 transition-all">
                    <span className="text-gray-300 text-sm">Temperature</span>
                    <span className="text-white font-semibold text-sm">{weather.temperature_2m}°C</span>
                </div>

                <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10 hover:border-green-400/50 transition-all">
                    <span className="text-gray-300 text-sm">Humidity</span>
                    <span className="text-white font-semibold text-sm">{weather.relative_humidity_2m}%</span>
                </div>

                <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10 hover:border-green-400/50 transition-all">
                    <span className="text-gray-300 text-sm">Wind Speed</span>
                    <span className="text-white font-semibold text-sm">{weather.wind_speed_10m} km/h</span>
                </div>

                {weather.air_quality_index !== null && weather.air_quality_index !== undefined && (
                    <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10 hover:border-green-400/50 transition-all">
                        <span className="text-gray-300 text-sm">Air Quality</span>
                        <div className="flex items-center gap-2">
                            <span className={`font-semibold text-sm ${getAQIColor(weather.air_quality_index)}`}>
                                {getAQIDescription(weather.air_quality_index)}
                            </span>
                            <span className="text-gray-400 text-xs">({Math.round(weather.air_quality_index)})</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WeatherCard;
